import { Spinner } from "@ui/Spinner/Spinner"
import type { Ref } from "react"
import { styled, type HTMLStyledProps } from "styled-system/jsx"

export type LoaderProps = {
  /**
   * Whether the loader is visible
   * @default true
   */
  visible?: boolean | undefined
  ref?: Ref<HTMLSpanElement>
  children?: React.ReactNode
} & HTMLStyledProps<"span">

const Span = styled("span")

export const Loader: React.FC<LoaderProps> = ({
  children,
  visible = true,
  ref,
  ...rest
}) => {
  if (!visible) {
    return children
  }

  return (
    <Span
      ref={ref}
      display="grid"
      placeItems="center"
      {...rest}
    >
      <Span
        gridArea="1 / 1"
        display="flex"
        alignItems="center"
        gap="xs"
        visibility="hidden"
      >
        {children}
      </Span>
      <Spinner
        gridArea="1 / 1"
        size="inherit"
        borderWidth="0.125em"
        color="[inherit]"
      />
    </Span>
  )
}
